import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import { Card, Divider, FormControl, InputLabel, MenuItem, Select, Stack, Tab, Tabs, Box } from "@mui/material"
import {TabContext, TabPanel} from "@mui/lab";
import Loading from "../../components/Common/Loading";
import PaymentsCM from "../Payments/cm";
import ConsumablesCM from "../Consumables/cm";
import {stringify, parse} from "lossless-json";
import {getDeviceIdAbsentWarning} from "../../core/utils/constants";
import WarningTwoToneIcon from "@mui/icons-material/WarningTwoTone";
import InAppCM from "../Payments/InAppCM";
import TechInfoCM from "../TechInfo/techInfoCM";
import Levels from "../UserStates/cm/Levels";
import PurchaseCM from "./cmPurchase";
import CmUserConnections from "../UserConnections/CmUserConnections"


function AnalyticsCM(props) {
    const {action, tab: tabParam, subtab: subTabParam, game} = useParams()
    const CommonData = useSelector((state) => state.data.CommonData)
    const deviceId = CommonData.deviceId
    const stateId = CommonData.stateId

    const link_prefix = '/' + game + '/' + action + '/' + deviceId + '/'
    const link_postfix = '?vendorId='+stateId

    const tab = tabParam || ''
    const subTab = subTabParam || 'houses';
    const ingameSubTab = subTabParam || 'main';
    const dispatch = useDispatch();
    const deviceIdIsEmpty = deviceId == null || deviceId == '' || typeof deviceId == 'object';

    const version = window.localStorage.getItem('isProd') == 'true' ? 'v2' : 'v2';



    const [tabIndex, setTabIndex] = useState(tab);
    const [subTabIndex, setSubTabIndex] = useState(subTab);
    const [ingameSubTabIndex, setIngameSubTabIndex] = useState(ingameSubTab);
    const [depth, setDepth] = useState("0")

    const handleTabChange = (event, newTabIndex) => {
        setDepth("0")
        setTabIndex(newTabIndex);
    };

    const handleSubTabChange = (event, newTabIndex) => {
        setSubTabIndex(newTabIndex);
    };

    const handleIngameSubTabChange = (event, newTabIndex) => {
        setIngameSubTabIndex(newTabIndex);
    };

    useEffect(() => {

    }, [deviceId, dispatch]);

    let status = ""

    let content = ""
    let panel1 = ""
    let panel2 = ""

    let charges = ""

    if (deviceIdIsEmpty) {
        return (
            <>
                <div>{getDeviceIdAbsentWarning()}</div>
            </>
        );
    }


    if(!deviceIdIsEmpty) {
        content = <TabContext value={tabIndex}>
            <Card>
                <Stack direction="row" alignItems="center" spacing={2} sx={{ pl: 2}}>
                    <Box sx={{pt:1}}>
                        <FormControl size="small" sx={{ minWidth: (theme) => theme.spacing(15) }}>
                            <InputLabel id="analytics-depth-label">Depth</InputLabel>
                            <Select
                                labelId="analytics-depth-label"
                                label="Depth"
                                value={depth}
                                onChange={e => setDepth(e.target.value)}
                            >
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                                <MenuItem value="3">3 (not recommended)</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <Divider orientation="vertical" flexItem />
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{ flexGrow: 1, minWidth: 0 }}
                    >
                        <Tab label="Balance items" value="balance_items" component={Link} to={link_prefix + "balance_items" + link_postfix}/>
                        <Tab label="Payments" value="payments" component={Link} to={link_prefix + "payments" + link_postfix}/>
                        <Tab label="Purchase" value="purchase" component={Link} to={link_prefix + "purchase" + link_postfix}/>
                        <Tab label="Inapp" value="inapp" component={Link} to={link_prefix + "inapp" + link_postfix}/>
                        <Tab label="Device" value="device" component={Link} to={link_prefix + "device" + link_postfix}/>
                        <Tab label="Levels" value="levels" component={Link} to={link_prefix + "levels" + link_postfix}/>
                        <Tab label="Connections" value="connections" component={Link} to={link_prefix + "connections" + link_postfix}/>
                    </Tabs>
                </Stack>
            </Card>

            <Box sx={{mt:0}}>
                <TabPanel value="">
                    Choose tab
                </TabPanel>
                <TabPanel value="balance_items">
                    <ConsumablesCM deviceId={deviceId} depth={depth} />
                </TabPanel>
                <TabPanel value="payments">
                    <PaymentsCM deviceId={deviceId} depth={depth} />
                </TabPanel>
                <TabPanel value="purchase">
                    <PurchaseCM deviceId={deviceId} depth={depth} />
                </TabPanel>
                <TabPanel value="inapp">
                    <InAppCM deviceId={deviceId} depth={depth} />
                </TabPanel>
                <TabPanel value="device">
                    <TechInfoCM isSimple={true} deviceId={deviceId} depth={depth} />
                </TabPanel>
                <TabPanel value="levels">
                    <Levels deviceId={deviceId} depth={depth} />
                </TabPanel>
                <TabPanel value="connections">
                    <CmUserConnections deviceId={deviceId} depth={depth} />
                </TabPanel>
            </Box>
        </TabContext>
    }


    return (
        <Stack direction="column">
            {content}
        </Stack>
    );

}

export default AnalyticsCM
